import React, { Component } from 'react'
import InfoIcon from '@material-ui/icons/Info';
import {proto,url} from '../../Helpers/api';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import MyDialog from '../MoreInfo/MyDialog';
import styled from 'styled-components';

const Content = styled.div`
  padding: 15px;
`

class ConnData extends Component {
  state = { connected: false, err: null }
  componentDidMount() {
    this.check();
    this.timer = setInterval(this.check, 60000);
  }
  check = () => {
    fetch(`${proto}://${url}/check`)
      .then(r => r.text())
      .then(r => this.setState({ connected: eval(r), err: null }))
      .catch(err => this.setState({ connected: false, err }))
  }
  disconnect = () => {
    fetch(`${proto}://${url}/disconnect`)
      .then(r => r.text())
      .then(r => this.setState({ connected: eval(r), err: null }))
      .catch(err => this.setState({ connected: false, err }))
  }
  connect = () => {
    fetch(`${proto}://${url}/connect`)
      .then(res => eval(res.text()))
      .then(connected => this.setState({ connected, err: null }))
      .catch(err => this.setState({ connected: false, err }))
  }
  render() {
    const { connected } = this.state;
    const ConnWidget = MyDialog(ConnDialog)
    return (
      <ConnWidget>
        <ConnectionWidget
          connected={connected}
          connect={this.connect}
          disconnect={this.disconnect}
        />
      </ConnWidget>
    )
  }
}

const ConnDialog = props => {
  const { dados={} } = props;
  const { status, connected, connect, disconnect } = dados;
  return (
    <Content>
      <div>Status Atual: {status}</div>
      <Button
        fullWidth
        variant="outlined"
        onClick={connected ? ()=>disconnect() : ()=>connect()}
      >
        {connected ? "Desconectar" : "Conectar"}
      </Button>
    </Content>
  )
}

const ConnectionWidget = props => {
  const { modalSetData, connected, connect, disconnect } = props;
  let status = connected ? "Conectado" : "Desconectado"
  return (
    <Tooltip title={status} >
      <InfoIcon style={{color: connected ? "green" : "red"}}
        onClick={() => modalSetData({
          status, connected, connect, disconnect
        })} />
    </Tooltip>
  )
}

export default ConnData;
